import React, { Component } from "react";

import styles from "./cmsUser.module.scss";
import { withUsers } from "../../../shared/containers/containerUsers";
import Scrollbars from "react-custom-scrollbars-2";

class CmsUserRolePermissions extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { currentUser, height = 650 } = this.props;

    return (
      <div className={styles.cmsUserRolePermissionsContainer}>
        <Scrollbars ref="scrollbar" style={{ height: height + "px" }} autoHide={false}>
          {currentUser.role.classificationPermissions.map((classification) => {
            return (
              <div key={classification.classPermission}>
                <strong>{classification.title}</strong>
                <div>
                  {classification.permissions.map((permission, index) => {
                    return (
                      <div key={permission.id} className={styles.permissionItemInfo}>
                        {index + 1}. {permission.title}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default withUsers(CmsUserRolePermissions);
